import { useMemo } from "react";

/**
 * Custom hook to check if the current date is within a specified day range of the month
 * @param startDay - The start day of the range (inclusive)
 * @param endDay - The end day of the range (inclusive)
 * @returns boolean indicating if the current date is within the specified range
 */
export const useIsDateInRange = (startDay: number, endDay: number): boolean =>
	useMemo(() => {
		const currentDate = new Date();
		const currentDay = currentDate.getDate();
		return currentDay >= startDay && currentDay <= endDay;
	}, [startDay, endDay]);
